<div class="wrap">
    <div class="uk-margin uk-display-inline-block research-form-controls">
        <div class="uk-form-controls uk-display-inline-block uk-position-relative" style="width: 325px;">
            <span *ngIf="societyLoading === true" class="uk-form-icon uk-form-icon-flip">
                <div uk-spinner></div>
            </span>
            <input class="search-bar" type="text" [(ngModel)]="societySearch"
                (ngModelChange)="updateSocietyOptionList($event)"
                (focus)="toggleSuggestions(true)" (focusout)="toggleSuggestions(false)"
                placeholder="Nom de l'adhérent" style="padding-right: inherit !important;"
            >
            <div [class.display-none]="societyDisplay === false" class="suggestions">
                <div [class.display-none]="societyOptions.length === 0" class="arrow"></div>
                <div [class.display-none]="societyNoResult === false">
                    Pas de résultats
                </div>
                <div [class.display-none]="societyNoResult === true" *ngFor="let option of societyOptions"
                    (click)="setSocietySearch(option)"
                >
                    {{ option.Code }}
                </div>
            </div>
        </div>
    </div>

    <button class="uk-button small-button uk-display-inline-block uk-float-right" type="submit" (click)="search(page, true)" style="margin-right: 40px;">
        <img src="../../../../assets/icons/Search.svg" width="24px" height="24px" alt="user" style="margin-top: -2px"/>
    </button>

    <div *ngIf="noResult === true" class="bold uk-margin-medium-top">
        Vous n'avez pas de factures.
    </div>

    <div *ngIf="loadingStatus === true" class="uk-position-center">
        <div uk-spinner></div>
    </div>

    <div *ngIf="invoices.length > 0">
        <div class="container" style="margin-left: 40px; margin-right: 40px;">
            <div class="uk-grid-small" uk-grid>
                <div *ngFor="let invoice of invoices; let i = index" class="uk-width-1-1">
                    <div class="uk-card uk-card-body card uk-grid-small" style="padding: 10px; margin-left: -10px;" uk-grid>
                        <div class="uk-width-1-3">
                            <span class="uk-card-title uk-display-block uk-text-bold">Virement du <span humanDateFormat="{{ invoice.ISOBillingDate }}" noDay="true" shortened="true"></span></span>
                        </div>
                        <div class="uk-width-1-3">
                            <span>Somme encaissée par Galago pour ces réservations</span>
                            <span class="uk-display-block uk-text-large uk-margin-small">
                                Inconnu
                            </span>
                        </div>
                        <div class="uk-width-1-3">
                            <span>Somme versée par Galago à {{ society.Name }}</span>
                            <span class="uk-display-block uk-text-large uk-margin-small uk-text-bold" *ngIf="invoice.InvoiceFields.length > 0">
                                {{ invoice.InvoiceFields[0].IncludingTaxes }}€
                            </span>
                            <span class="uk-display-block uk-text-large uk-margin-small uk-text-bold" *ngIf="invoice.InvoiceFields.length === 0">
                                Inconnu
                            </span>
                        </div>
                                                
                        <div class="uk-width-3-3 uk-text-bold uk-text-right" style="padding-right: 15px;">
                            <a class="uk-text-baseline" (click)="downloadInvoice(invoice.IdInvoice)">télécharger la facture</a> <br>
                            <a class="uk-text-baseline" [routerLink]="['/reservation/informations', invoice.IdBooking]">voir la réservation</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="uk-position-relative uk-width-1-1 uk-padding">
            <div class="uk-position-center">
                <button [disabled]="moreResultsAvailable === false" class="uk-button uk-button-default" (click)="search(page + 1)">
                    Voir plus
                </button>
            </div>
        </div>
    </div>

</div>